import { Children, type ReactNode } from 'react';
import { Stack } from '@mui/material';

export const Container = ({ children }: { children: ReactNode }) => {
  const childrenArray = Children.toArray(children);

  const headingElement = childrenArray[0];
  const bottomElements = childrenArray.slice(1);

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      spacing={2}
      p={2}
      flex={1}
      height="100%"
    >
      {headingElement && <Stack>{headingElement}</Stack>}
      {bottomElements.length > 0 && (
        <Stack direction="column" spacing={2}>
          {bottomElements}
        </Stack>
      )}
    </Stack>
  );
};
